import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSearchNews } from '../../../../../redux/slices/newsSlice';
import { setLastPublicationNumber } from '../../../../../redux/slices/appSlice';
import { setPaginationPage } from '../../../../../redux/slices/paginationSlice';
import { setSelectedPostFilterWithUpdate } from '../../../../../redux/actions/filterActions';
import styles from './index.module.scss';

// Презентационный компонент: рендерит переданный элемент без какой-либо бизнес-логики
// Принимает path_to_folder аналогично компоненту header_logo_block
const NewsLineBlock = ({
  item,
  onItemClick,
  path_to_folder = null,
  hasDragged = false,
  blockIndex = null,
  sectionPageNumber = null,
  globalIndex = null,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (!item) return null;

  const parentTab = item.parent_tab;
  const parentTabShowName = item.parent_tab_show_name;
  const sectionPosition = item.section_position;
  const templateName = item.template?.template_name;
  const engName = item.eng_name;

  const handleClick = () => {
    // Если было перетаскивание, не выполняем клик
    if (hasDragged) return;

    if (templateName === 'publication_v1') {
      // Если parent_tab равен main_tab, то путь должен быть '/'
      const url = parentTab === 'main_tab' ? '/' : `/${parentTab}/${engName}`;
      navigate(url);
    } else if (templateName === 'publication_v2') {
      // Если parent_tab равен main_tab, то путь должен быть '/'
      const url = parentTab === 'main_tab' ? '/' : `/${parentTab}/${engName}`;
      navigate(url);
    } else if (templateName === 'post') {
      // Если parent_tab равен main_tab, то путь должен быть '/'
      const url = parentTab === 'main_tab' ? '/' : `/${parentTab}`;

      // Переходим на страницу раздела
      navigate(url);

      // Устанавливаем фильтр для показа только этого поста
      setTimeout(() => {
        dispatch(setSelectedPostFilterWithUpdate(engName));
      }, 100);
    }
    if (onItemClick) {
      onItemClick(item);
    }
  };
  // Переводим строку list[0].content в объект (если это JSON)
  const parseJSON = (str) => {
    if (typeof str !== 'string' || str.trim() === '') return null;
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  };
  const contentObject = parseJSON(item?.content);
  const hasContentObject = contentObject && typeof contentObject === 'object';
  const first = Array.isArray(contentObject) ? contentObject[0] : null;
  const blockContent = first && Array.isArray(first.block_content) ? first.block_content : [];

  // Резолвим path_to_folder: либо из пропса, либо из самой публикации
  const resolvedPathToFolder = (() => {
    if (path_to_folder) return path_to_folder;
    if (item && item.path && (item.eng_name || item.blank_name)) {
      return 'https://' + item.path + (item.eng_name || item.blank_name) + '/';
    }
    return '';
  })();

  // Определяем src фонового изображения (если есть 3-я картинка — используем её, иначе первую)
  const bgSrc = (() => {
    const imgNames = blockContent
      .filter((el) => el && (el.cotent_type === 'img' || el.content_type === 'img') && el.img_name)
      .map((el) =>
        typeof el.img_name === 'string'
          ? el.img_name.replace(/\\/g, '/').split('/').pop().trim()
          : el.img_name,
      )
      .filter((name) => !!name && name !== 'none');
    if (imgNames.length === 0) return null;
    const picked = imgNames[2] || imgNames[0];
    const full = (resolvedPathToFolder || '') + (typeof picked === 'string' ? picked : '');
    return encodeURI(full);
  })();

  if (hasContentObject) {
    // Выводим JSON-данные в консоль
    // Оригинальная строка
    // Распарсенный объект

    // Если это массив блоков, логируем все элементы contentObject[0].block_content
    if (blockContent.length > 0) {
      blockContent.forEach((el, idx) => {});
    } else {
    }
  }
  return (
    <div
      className={styles.newsLineBlock}
      data-has-content={hasContentObject ? '1' : '0'}
      style={bgSrc ? { backgroundImage: `url(${bgSrc})` } : undefined}>
      {bgSrc && <img src={bgSrc} alt='' aria-hidden='true' className={styles.bgImage} />}
      {/* {blockIndex && <div className={styles.blockIndex}>#{blockIndex}</div>} */}
      {/* {parentTabShowName && (
        <div className={styles.sectionName}>
          {parentTabShowName}
          {sectionPosition && <span className={styles.sectionPosition}> #{sectionPosition}</span>}
          {sectionPageNumber && (
            <span className={styles.sectionPage}> (стр.{sectionPageNumber})</span>
          )}
        </div>
      )} */}
      <div className={styles.items}>
        <button type='button' className={styles.item} onClick={handleClick}>
          {hasContentObject && blockContent.length > 0 && (
            <div className={styles.texts}>
              {blockContent
                .filter((el) => el && (el.cotent_type === 'text' || el.content_type === 'text') && el.content_text)
                .map((el, i) => (
                  <p key={`txt-${i}`} className={styles.text}>
                    {el.content_text?.split('\n').map((line, lineIndex) => (
                      <React.Fragment key={lineIndex}>
                        {line}
                        {lineIndex < el.content_text.split('\n').length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </p>
                ))}
              {/* Изображения как фон блока, поэтому дополнительные <img> не рендерим */}
              {/**
               * Закомментирован вывод long_text по просьбе пользователя
               * {blockContent
               *   .filter((el) => el && el.cotent_type === 'long_text' && el.content_text)
               *   .map((el, i) => (
               *     <p key={`ltext-${i}`} className={styles.text}>
               *       {truncate(el.content_text, 180)}
               *     </p>
               *   ))}
               */}
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default NewsLineBlock;
